import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { Observable } from 'rxjs';
import { AvailablePlatform } from '@eightcap/core';
import { map } from 'rxjs/operators';

@Injectable()
export class AvailablePlatformService extends CrudBaseService<AvailablePlatform> {
    constructor(httpClient: HttpClient) {
        super('/tenant', httpClient);
    }

    getByCountry(countryCode: string, tenant: string, isLive: boolean = true): Observable<AvailablePlatform[]> {
        const sufFix = isLive ? '-L' : '-D';
        return this.httpClient
            .get(`${this.basePath}/${tenant}/platform/${isLive ? 'Live' : 'Demo'}/${countryCode}`)
            .pipe(
                map((res: any) => res && res.data),
                map((data) =>
                    Object.keys(data).map((k) => ({ ...data[k], code: k + sufFix, id: k + sufFix, name: k + sufFix })),
                ),
            );
    }
}
